import React, { Component } from 'react';
import { HorizontalBar } from 'react-chartjs-2';

class ReportDishChart extends Component {
  render() {
    const { data } = this.props;
    const listLabel = data.map(menu => menu.name);
    const listValue = data.map(menu => menu.dish_sum);
    const dataChart = {
      labels: listLabel,
      datasets: [
        {
          label: 'Doanh số',
          backgroundColor: '#4285F4',
          borderColor: '#4285F4',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: listValue,
        },
      ],
    };
    const chartHeight = listLabel.length * 10;
    return (
      <HorizontalBar
        key={chartHeight}
        data={dataChart}
        height={chartHeight || undefined}
      />
    );
  }
}

export default ReportDishChart;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportDish/components/ReportDishChart.jsx